import * as constants from 'constants/intl-constants';

import union from 'lodash/union';

import {createReducer} from 'redux-store';

export type IntlStore = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formats: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    messages: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    modules: any;
};

const initialState = () => {
    return {
        formats: {
            /**
             * Warning: do not specify any `timeZone` setting in these formats. Most
             * browsers do not support any value for `timeZone` other than 'UTC', so
             * we need to fall back to the local time to avoid throwing exceptions.
             */
            date: {
                longDateTime: {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                },
                preciseDateTime: {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: true,
                },
                shortDateTime: {
                    // Sep 20, 2019, 3:12 PM
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                },
                mediumDate: {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                },
                longDate: {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                },
                shortDate: {
                    // en-US: 09/20/2019
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                },
                date: {
                    day: 'numeric',
                },
                month: {
                    month: 'long',
                },
                monthAndDay: {
                    month: 'short',
                    day: 'numeric',
                },
                yearAndMonth: {
                    year: 'numeric',
                    month: 'short',
                },
                timeOfDay: {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                },
            },
            // For duration, we can use the local browser timezone.
            duration: {
                sessionTicks: {
                    minute: 'numeric',
                    second: 'numeric',
                },
            },
        },
        messages: {},
        modules: [],
    };
};

const actionsMap = {
    [constants.SET_FORMATS]: (state, action) => {
        return {
            formats: {...state.formats, ...action.formats},
        };
    },
    [constants.SET_MESSAGES]: (state, action) => {
        return {
            messages: {...state.messages, ...action.messages},
            modules: union(state.modules, action.moduleNames),
        };
    },
};

export default createReducer<IntlStore>(initialState(), actionsMap);
